module.exports = __webpack_public_path__ + "static/inner_01-f423f712f335059030ace8c78c5b1abf.png";